import GetAvailabilityStatus from './GetAvailabilityStatus';

export default GetAvailabilityStatus;
